import apiClient from "./axios"
import { downloadAndOpenFile } from "./pdfApi"

// ✅ Get accessories usage records (with filters / pagination)
export const getAccessoriesUsageList = async (params = {}) => {
  const { data } = await apiClient.get("/accessories-usages", { params })
  return data
}

// ✅ Get single accessories usage by ID
export const getAccessoriesUsageById = async id => {
  const { data } = await apiClient.get(`/accessories-usages/${id}`)
  return data
}

// ✅ Get single accessories usage pdf by ID
export const getAccessoriesUsagePdfById = (id, setLoading) => {
  return downloadAndOpenFile({
    url: `/accessories-usages/pdf/${id}`,
    mimeType: "application/pdf",
    openInNewTab: true,
    onStart: () => setLoading?.(true),
    onEnd: () => setLoading?.(false),
  })
}

// ✅ Get accessories usage bill PDF by ID
export const getAccessoriesUsageBillPdfById = (id, setLoading) => {
  return downloadAndOpenFile({
    url: `/accessories-usages/bill-pdf/${id}`,
    mimeType: "application/pdf",
    openInNewTab: true,
    onStart: () => setLoading?.(true),
    onEnd: () => setLoading?.(false),
  })
}

// ✅ Create accessories usage record
export const createAccessoriesUsage = async payload => {
  const { data } = await apiClient.post("/accessories-usages", payload)
  return data
}

// ✅ Update accessories usage record
export const updateAccessoriesUsage = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/accessories-usages/${id}`, payload)
  return data
}

// ✅ Soft delete (move to trash)
export const deleteAccessoriesUsage = async id => {
  const { data } = await apiClient.delete(`/accessories-usages/${id}`)
  return data
}

// ✅ Get trashed accessories usage records
export const getTrashedAccessoriesUsages = async (params = {}) => {
  const { data } = await apiClient.get("/accessories-usages/trashed", {
    params,
  })
  return data
}

// ✅ Restore trashed accessories usage record
export const restoreAccessoriesUsage = async id => {
  const { data } = await apiClient.post(`/accessories-usages/${id}/restore`)
  return data
}

// ✅ Permanently delete accessories usage record
export const forceDeleteAccessoriesUsage = async id => {
  const { data } = await apiClient.delete(
    `/accessories-usages/${id}/force-delete`
  )
  return data
}
